import getStringDateAndHourFromDate from '../../../localUtils/getStringDateAndHourFromDate'

export default function getYesterday() {
  const today = new Date()
  const yesterday = new Date()

  yesterday.setDate(yesterday.getDate() - 1)

  const stringToday = getStringDateAndHourFromDate(today)
  const stringYesterday = getStringDateAndHourFromDate(yesterday)

  const options = {
    name: 'YESTERDAY',
    label: 'Ontem',
    startDate: stringYesterday.date,
    finalDate: stringToday.date,
    startHour: '00:00',
    finalHour: '23:59',
  }

  return options
}
